import { componentProvider } from 'js-component-framework/es';
import ToggleButton from '@/js/ToggleButton';
import ModalDialog from '@/js/ModalDialog';
import './product-supplemental.scss';

/**
 * ProductSupplemental component.
 */
class ProductSupplemental {
  items = [];

  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    this.init();
  }

  init = () => {
    const { toggles, excerpt, checkExam } = this.children;

    toggles.forEach((toggle, index) => {
      this.items.push(new ToggleButton(toggle, { loadOpen: (index === 0) }));
    });

    if (excerpt !== null) {
      this.excerptButton = new ModalDialog(excerpt, { close: '.excerpt-modal__close' });
    }

    if (checkExam !== null) {
      const config = JSON.parse(checkExam.innerText);

      fetch(config.endpoint)
        .then((res) => {
          if (res.ok) {
            return res.json();
          }

          throw new Error();
        })
        .then((json) => {
          checkExam.insertAdjacentHTML(config.position, json.content);
        })
        .catch(() => {
          // Unused.
        });
    }
  }
}

const productSupplementalConfig = {
  name: 'product-supplemental',
  component: ProductSupplemental,
  querySelector: {
    excerpt: '.product-supplemental__excerpt',
    checkExam: '.product-supplemental__check-exam',
  },
  querySelectorAll: {
    toggles: '.product-supplemental__toggle',
  },
};

componentProvider(productSupplementalConfig);
